import { render, staticRenderFns } from "./EditBasicDetail.vue?vue&type=template&id=4ce6a2ba&scoped=true&"
import script from "./EditBasicDetail.vue?vue&type=script&lang=js&"
export * from "./EditBasicDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditBasicDetail.vue?vue&type=style&index=0&id=4ce6a2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6a2ba",
  null
  
)

export default component.exports